<div class="w-[235px] h-[178px] shrink-0 bg-white border border-gris-3 rounded-[5px] relative overflow-hidden">
  <!-- Icône catégorie (fond coloré + image service) -->
  <div class="absolute top-[20px] left-[15px] size-[40px] rounded-[5px] shrink-0 relative overflow-hidden"
    [style.background]="bgColor()">
    @if (imageUrl()) {
    <img [src]="imageUrl()" class="absolute inset-0 w-full h-full object-contain" alt="" />
    }
  </div>
  <!-- Nom du plat -->
  <div
    class="absolute top-[20px] left-[65px] right-[15px] h-[2em] line-clamp-2 text-[19px] font-semibold fg-noir-2 leading-[20px] overflow-hidden">
    {{ course().name }}
  </div>
  <!-- Allergènes et labels -->
  @if ((course().allergens?.length ?? 0) > 0 || (course().labels?.length ?? 0) > 0) {
  <div class="absolute top-[68px] left-[15px] right-[15px] h-[22px] flex items-center justify-between cursor-pointer"
    (click)="toggleInfoTooltip($event)">
    <span class="h-full flex items-center gap-1 leading-none">
      @for (allergen of course().allergens; track allergen.id) {
      @if (allergen.logo) {
      @if (!brokenLogoKeys().has('allergen-' + allergen.id)) {
      <img [src]="allergen.logo" [alt]="allergen.name" class="h-full w-auto object-contain"
        (error)="markLogoBroken('allergen-' + allergen.id)" />
      } @else {
      <span
        class="h-full aspect-square flex items-center justify-center rounded-full bg-gris-1 fg-blanc text-[11px] font-semibold">?</span>
      }
      }
      }
    </span>
    <span class="h-full flex items-center gap-1 leading-none">
      @for (label of course().labels; track label.id) {
      @if (label.logo) {
      @if (!brokenLogoKeys().has('label-' + label.id)) {
      <img [src]="label.logo" [alt]="label.name" class="h-full w-auto object-contain"
        (error)="markLogoBroken('label-' + label.id)" />
      } @else {
      <span
        class="h-full aspect-square flex items-center justify-center bg-gris-1 fg-blanc text-[11px] font-semibold">?</span>
      }
      }
      }
    </span>
  </div>
  }
  @if (showInfoTooltip()) {
  <div class="fixed z-50 bg-white border border-gris-3 rounded-[5px] shadow-lg px-3 py-2 text-[14px] fg-noir-2"
    [style.top.px]="tooltipPosition().top" [style.left.px]="tooltipPosition().left" (click)="$event.stopPropagation()">
    @for (allergen of course().allergens; track allergen.id) {
    <div class="flex items-center gap-2 whitespace-nowrap">
      @if (allergen.logo) {
      @if (!brokenLogoKeys().has('allergen-' + allergen.id)) {
      <img [src]="allergen.logo" [alt]="allergen.name" class="size-[16px] object-contain"
        (error)="markLogoBroken('allergen-' + allergen.id)" />
      } @else {
      <span
        class="size-[16px] flex items-center justify-center rounded-full bg-gris-1 fg-blanc text-[11px] font-semibold">?</span>
      }
      }
      {{ allergen.name }}
    </div>
    }
    @for (label of course().labels; track label.id) {
    <div class="flex items-center gap-2 whitespace-nowrap">
      @if (label.logo) {
      @if (!brokenLogoKeys().has('label-' + label.id)) {
      <img [src]="label.logo" [alt]="label.name" class="size-[16px] object-contain"
        (error)="markLogoBroken('label-' + label.id)" />
      } @else {
      <span class="size-[16px] flex items-center justify-center bg-gris-1 fg-blanc text-[11px] font-semibold">?</span>
      }
      }
      {{ label.name }} ({{ label.comment }})
    </div>
    }
  </div>
  }
  <!-- Séparateur horizontal -->
  <div class="absolute top-[103px] left-0 right-0 h-px bg-gris-3"></div>
  <!-- Label prix -->
  <div class="absolute top-[128px] left-[15px] text-[14px] fg-gris-1 font-semibold leading-none">
    @if (!showPrice()) {
    {{ 'order.included' | translate }}
    } @else {
    {{ course().price ?? 0 | formatPrice }}
    }
  </div>
  <!-- Sélecteur de quantité -->
  <app-quantity-selector [quantity]="quantity()" [disabled]="disabled()" [readOnly]="readOnly()"
    (increment)="increment.emit()" (decrement)="decrement.emit()" />
</div>